export const MAX_FILE_SIZE = 1024 * 15 * 1000; // 15MB;
